
import { CheckCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";

interface M365CaseStudySummaryProps {
  title: string;
  industry: string;
  challenge: string;
  solution: string;
  results: string[];
  cta: string;
  link: string;
}

export const M365CaseStudySummary = ({
  title,
  industry,
  challenge,
  solution,
  results,
  cta,
  link
}: M365CaseStudySummaryProps) => {
  return (
    <Card className="overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 h-full flex flex-col bg-gradient-to-b from-white to-gray-50">
      <div className="h-2 bg-gradient-to-r from-edgefi-purple via-edgefi-amethyst to-edgefi-blue"></div>
      <div className="p-6 flex flex-col h-full">
        <div className="mb-4">
          <span className="text-sm font-medium bg-edgefi-purple/10 text-edgefi-purple py-1.5 px-4 rounded-full">
            {industry}
          </span>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold text-edgefi-black mb-5 leading-tight">
          {title}
        </h3>
        
        <div className="space-y-5 mb-6 flex-grow">
          <div className="bg-white p-4 rounded-lg border border-gray-100">
            <h4 className="text-sm font-semibold text-edgefi-purple mb-2 flex items-center">
              <span className="w-1.5 h-1.5 bg-edgefi-purple rounded-full mr-2" aria-hidden="true" />
              The Challenge
            </h4>
            <p className="text-gray-700">{challenge}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg border border-gray-100">
            <h4 className="text-sm font-semibold text-edgefi-purple mb-2 flex items-center">
              <span className="w-1.5 h-1.5 bg-edgefi-purple rounded-full mr-2" aria-hidden="true" />
              Our Solution
            </h4>
            <p className="text-gray-700">{solution}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg border border-gray-100">
            <h4 className="text-sm font-semibold text-edgefi-purple mb-2 flex items-center">
              <span className="w-1.5 h-1.5 bg-edgefi-purple rounded-full mr-2" aria-hidden="true" />
              Results
            </h4>
            <div className="space-y-3">
              {results.map((result, index) => (
                <div key={index} className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-edgefi-chartreuse mt-0.5 flex-shrink-0" />
                  <p className="text-gray-700">{result}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <Link 
          to={link}
          className="inline-flex items-center justify-center text-edgefi-purple font-medium hover:text-edgefi-amethyst group mt-2 bg-edgefi-purple/5 py-3 px-4 rounded-lg"
        >
          {cta}
          <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </Card>
  );
};
